import { UserModel, UserModelData } from './user-model';
import { castToModel } from "../providers/utils-provider.service";
import { User } from "./user";


export interface ParticipantModelData {
    _id?: number;
    _seenAt?: string;
    _user?: UserModelData;

}
export class ParticipantModel {
    id?: number;
    seenAt?: string;
    user?: UserModel;

    public static fromApi(data: ParticipantModelData): ParticipantModel {
        return new ParticipantModel(data);
    }

    public static fromApiList(data: ParticipantModelData[]): ParticipantModel[] {
        return data.map((item: ParticipantModelData) => ParticipantModel.fromApi(item));
    }

    constructor({_id, _seenAt, _user}: ParticipantModelData) {
        this.id = _id;
        this.seenAt = _seenAt;
        this.user = _user ? UserModel.fromApi(_user) : undefined;
    }


}
